<template>
  <div>
    <form v-if="client" class="form__group" @submit.prevent="saveClient()">
      <div v-if="!isScormClientAdmin" class="account__block">
        <div class="account__block--title">{{ $t('account.forms.notificationStudents') }}</div>
        <div class="form__row">
          <div class="form__group u-margin-bottom">
            <gl-select
              id="config.lang"
              v-skeletor:onChange="selectLang"
              :label="$t('account.forms.langNotifications')"
              :placeholder="$t('account.forms.langNotifications')"
              :tooltip="$t('account.forms.langNotificationsTooltip')"
              :options="JSON.stringify(getExtendedLanguages)"
              :value="JSON.stringify(clientData.lang)"
              :separator="true"
              :errormessage="!clientData.lang ? $t('account.errors.fieldRequired') : null"
            >
            </gl-select>
          </div>
          <!-- This is uppercase because of 'account.lms${type}' labels (set in subscriptions store) -->
          <div v-if="subscriptionType === 'Users'" class="account__block--checkbox u-margin-top">
            <gl-checkbox
              id="config.notifications.n1"
              v-model="clientData.notificationsCfg.n1.enabled"
              v-skeletor:onChange="setNotifications"
              :label="$t('account.forms.sendMailActivation')"
              :tooltip="$t('account.forms.sendMailActivationTooltip')"
              :checked="clientData.notificationsCfg.n1.enabled"
              :small="true"
            >
            </gl-checkbox>
          </div>
          <div class="account__block--checkbox">
            <gl-checkbox
              id="config.notifications.n4"
              v-model="clientData.notificationsCfg.n4.enabled"
              v-skeletor:onChange="setNotifications"
              :label="$t('account.forms.sendMailConfirmation')"
              :tooltip="$t('account.forms.sendMailConfirmationTooltip')"
              :checked="clientData.notificationsCfg.n4.enabled"
              :small="true"
            >
            </gl-checkbox>
          </div>
          <div class="account__block--checkbox">
            <div class="checkbox small-check">
              <input
                id="config.sendMailAnimation"
                v-model="clientData.notificationsCfg.n3.enabled"
                type="checkbox"
                name="checkbox"
                @change="onSendMailAnimationChange"
              />
              <label for="config.sendMailAnimation">{{
                $t('account.forms.sendMailAnimation')
              }}</label>
            </div>
            <button id="config.btn-sendMailAnimation" class="un-btn" gltooltip="" type="button">
              <span class="glicon-info-outline"></span>
              <div class="gl-tooltip top center">
                {{ $t('account.forms.sendMailAnimationTooltip') }}
              </div>
            </button>
          </div>
          <div v-if="client.type === 'corporate'" class="account__block--checkbox">
            <gl-checkbox
              id="config.notifications.n8"
              v-model="clientData.notificationsCfg.n8.enabled"
              v-skeletor:onChange="setNotifications"
              :label="$t('account.forms.sendMailKirkpatrick')"
              :tooltip="$t('account.forms.sendMailKirkpatrickTooltip')"
              :checked="clientData.notificationsCfg.n8.enabled"
              :small="true"
            >
            </gl-checkbox>
          </div>
          <div v-if="client.type === 'corporate'" class="account__block--checkbox">
            <div class="checkbox small-check">
              <input
                id="config.referrals"
                v-model="clientData.referrals"
                type="checkbox"
                name="checkbox"
                @change="onReferralChange"
              />
              <label for="config.referrals">{{ $t('account.forms.referrals') }}</label>
            </div>
            <button id="config.referrals" class="un-btn" gltooltip="" type="button">
              <span class="glicon-info-outline"></span>
              <div class="gl-tooltip top center">
                {{ $t('account.forms.sendMailReferralsTooltip') }}
              </div>
            </button>
          </div>
          <div class="form__group">
            <gl-select
              id="config.notifications.n3.weekPeriodicity"
              v-skeletor:onChange="setNotifications"
              :label="$t('account.forms.emailFrequencyAnimation')"
              :placeholder="$t('account.forms.emailFrequencyAnimation')"
              :options="JSON.stringify(frequencyOptions)"
              :value="JSON.stringify(clientData.notificationsCfg.n3.weekPeriodicity)"
              :disabled="!isN3Enabled"
              :separator="true"
              :errormessage="
                !clientData.notificationsCfg.n3.weekPeriodicity
                  ? $t('account.errors.fieldRequired')
                  : null
              "
            >
            </gl-select>
          </div>
        </div>
      </div>

      <!-- Ranking config -->
      <div class="account__block">
        <div class="account__block--title">{{ $t('account.forms.rankingStudents') }}</div>
        <div class="form__row">
          <div class="form__group">
            <gl-select
              id="config.ranking"
              v-skeletor:onChange="selectRankingFlag"
              :label="$t('account.forms.rankingVisibilityStudents')"
              :placeholder="$t('account.forms.rankingVisibilityStudents')"
              :options="JSON.stringify(rankingOptions)"
              :tooltip="$t('account.forms.rankingVisibilityStudentsTooltip')"
              :value="JSON.stringify(rankingInfo)"
              :separator="true"
              :errormessage="!clientData.ranking ? $t('account.errors.fieldRequired') : null"
            >
            </gl-select>
          </div>
        </div>
      </div>

      <!-- Catalogue config -->
      <div class="account__block">
        <div class="account__block--title">{{ $t('account.forms.catalogue') }}</div>
        <div class="form__row">
          <!-- Default access mode -->
          <div v-if="!isScormClientAdmin" class="form__group">
            <gl-select
              id="config.defaultAccessMode"
              v-skeletor:onChange="selectDefaultAccessMode"
              :label="$t('account.forms.defaultAccessMode')"
              :options="JSON.stringify(defaultAccessModeOptions)"
              :value="JSON.stringify(catalogueData.defaultAccessMode)"
              :separator="true"
              :errormessage="
                !catalogueData.defaultAccessMode ? $t('account.errors.fieldRequired') : null
              "
            >
            </gl-select>
          </div>
          <!-- Diploma visibility -->
          <div class="form__group">
            <gl-select
              id="config.shouldSendDiploma"
              v-skeletor:onChange="selectShouldSendDiploma"
              :label="$t('account.forms.shouldSendDiploma')"
              :options="JSON.stringify(shouldSendDiplomaOptions)"
              :value="
                JSON.stringify(
                  catalogueData.configuration.shouldSendDiploma ? 'enabled' : 'disabled'
                )
              "
              :separator="true"
              :errormessage="
                catalogueData.configuration.shouldSendDiploma == null
                  ? $t('account.errors.fieldRequired')
                  : null
              "
            >
            </gl-select>
          </div>
        </div>
      </div>

      <div class="account__block--buttons">
        <gl-button
          id="config.btn-save"
          color-primary
          :type="'submit'"
          :text="$t('account.forms.saveChanges')"
          :disabled="!dirtyFields"
          @onClick.prevent="saveClient()"
        ></gl-button>
      </div>
      <!-- Error modal -->
      <PopupClientConfig v-if="configWarning" @close="close($event)" />
      <PopupClientReferral v-if="referralWarning" @close="closeReferral($event)" />
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import PopupClientConfig from '@/components/Account/PopUps/PopupClientConfig.vue';
import PopupClientReferral from '@/components/Account/PopUps/PopupClientReferral.vue';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { formatIds } from '../utils/functions.js';

export default {
  name: 'ClientConfigPage',
  components: {
    PopupClientConfig,
    PopupClientReferral
  },
  data() {
    return {
      clientData: {
        lang: 'en',
        notificationsCfg: {
          n1: { enabled: true },
          n3: {
            enabled: true,
            weekPeriodicity: 1
          },
          n4: { enabled: true },
          n8: { enabled: true }
        },
        ranking: {},
        referrals: true
      },
      dirtyFields: false,
      frequencyOptions: [
        {
          key: 1,
          value: this.$i18n.t('account.config.weeks', { weeks: 1 })
        },
        {
          key: 2,
          value: this.$i18n.t('account.config.weeks', { weeks: 2 })
        },
        {
          key: 4,
          value: this.$i18n.t('account.config.weeks', { weeks: 4 })
        }
      ],
      rankingOptions: [
        { key: 'showRanking', value: this.$i18n.t('account.config.showRanking') },
        { key: 'obfuscateRanking', value: this.$i18n.t('account.config.obfuscateRanking') },
        { key: 'showAlias', value: this.$i18n.t('account.config.showAlias') }
      ],
      rankingInfo: 'showRanking',
      catalogueData: {
        defaultAccessMode: 'open',
        configuration: {
          shouldSendDiploma: true
        }
      },
      defaultAccessModeOptions: [
        { key: 'open', value: this.$i18n.t('account.config.accessModes.open') },
        { key: 'limited', value: this.$i18n.t('account.config.accessModes.limited') },
        { key: 'unavailable', value: this.$i18n.t('account.config.accessModes.unavailable') }
      ],
      shouldSendDiplomaOptions: [
        { key: 'enabled', value: this.$i18n.t('account.config.diploma.enabled') },
        { key: 'disabled', value: this.$i18n.t('account.config.diploma.disabled') }
      ],
      configWarning: false,
      referralWarning: false
    };
  },
  computed: {
    ...mapState({
      client: (state) => state.clients.clientData,
      catalogue: (state) => state.catalogues.catalogueData,
      subscriptionType: (state) => state.subscriptions.type
    }),
    isN3Enabled() {
      return this.clientData.notificationsCfg.n3.enabled;
    },
    ...mapGetters(['getExtendedLanguages', 'isScormClientAdmin'])
  },
  watch: {
    client(newValue) {
      this.clientData = { ...this.clientData, ...newValue };
    },
    catalogue: {
      deep: true,
      handler(newValue) {
        this.catalogueData = { ...this.catalogueData, ...newValue };
      }
    }
  },
  async created() {
    await this.loadClient();
    this.setClient();
  },
  methods: {
    ...mapActions(['getClientData', 'updateClient', 'getCatalogueData', 'updateCatalogue']),
    setValue(field, value, dirty) {
      this.setForm(formatIds(field), value);
      this.setDirtyField(dirty);
    },
    setForm(attr, value) {
      this.$set(this.form, attr, value);
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    },
    selectLang(attr, value, dirty) {
      this.$set(this.clientData, formatIds(attr), value);
      this.setDirtyField(dirty);
    },
    setNotifications(attr, value, dirty) {
      if (formatIds(attr) === 'n1') {
        this.$set(this.clientData.notificationsCfg.n1, 'enabled', value);
      }
      if (formatIds(attr) === 'n4') {
        this.$set(this.clientData.notificationsCfg.n4, 'enabled', value);
      }
      if (formatIds(attr) === 'n8') {
        this.$set(this.clientData.notificationsCfg.n8, 'enabled', value);
      }
      if (formatIds(attr) === 'weekPeriodicity') {
        this.$set(this.clientData.notificationsCfg.n3, 'weekPeriodicity', value);
      }
      this.setDirtyField(dirty);
    },
    selectRankingFlag(attr, value, dirty) {
      this.rankingInfo = value;
      this.setDirtyField(dirty);
    },
    selectDefaultAccessMode(attr, value, dirty) {
      this.catalogueData.defaultAccessMode = value;
      this.setDirtyField(dirty);
    },
    selectShouldSendDiploma(attr, value, dirty) {
      const actualValue = value === 'enabled' ? true : false;
      this.$set(this.catalogueData, 'configuration', { shouldSendDiploma: actualValue });
      this.setDirtyField(dirty);
    },
    setClient() {
      this.clientData = {
        ...this.clientData,
        ...this.client
      };
      this.rankingInfo =
        this.client && this.client.ranking && this.client.ranking.showAlias
          ? 'showAlias'
          : this.client && this.client.ranking && this.client.ranking.obfuscateRanking
          ? 'obfuscateRanking'
          : 'showRanking';

      this.catalogueData = {
        ...this.catalogueData,
        ...this.catalogue
      };
    },
    saveClient() {
      const ranking = {
        showRanking: this.rankingInfo === 'showRanking',
        showAlias: this.rankingInfo === 'showAlias',
        obfuscateRanking: this.rankingInfo === 'obfuscateRanking'
      };
      this.$set(this.clientData, 'ranking', ranking);

      const notification = {
        type: 'success',
        message: `feedback.success.changeAccountData`,
        fieldToEdit: 'changeAccountData',
        show: true
      };
      this.updateClient({
        body: this.clientData,
        notification
      });
      this.updateCatalogue({
        body: {
          defaultAccessMode: this.catalogueData.defaultAccessMode,
          configuration: {
            shouldSendDiploma: this.catalogueData.configuration.shouldSendDiploma
          }
        },
        notification
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    cancel() {
      this.$router.push({ name: 'profile' });
    },
    async loadClient() {
      if (!this.client) {
        await this.getClientData();
        await this.getCatalogueData();
      }
    },
    onSendMailAnimationChange(attr, value) {
      this.configWarning = !value;
    },
    onReferralChange(e) {
      this.referralWarning = !e.target.checked;
    },
    close(enabled) {
      this.clientData.notificationsCfg.n3.enabled = enabled;
      this.configWarning = false;
    },
    closeReferral(enabled) {
      this.clientData.referrals = enabled;
      this.referralWarning = false;
    }
  },
  validations: {
    clientData: {
      // TODO What if LG wants to become a client?
      name: { required, minLength: minLength(3) },
      surname: {},
      email: { required, email },
      pid: {},
      phone: {},
      timezone: { required },
      lang: { required },
      countryId: { required },
      role: { required }
    }
  }
};
</script>
